// extracted by mini-css-extract-plugin
export default {"select":"CurrencySelector_select__NgM04"};